// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2o3cd","footerLabel":"Footer_footerLabel__1GqWH"};